/**
 * Texte des Reiters „E-Mails" in der Kundenakte (V-2443, `CustomerMailVerlauf.tsx`).
 *
 * Eigener Namensraum statt Einträgen in den großen `web/src/i18n/locales/*.json` — die tragen große fremde, uncommittete
 * Änderungen anderer Sitzungen. Muster: `web/src/components/settings/shopPflichtmails/i18n.ts` (Registrierung in
 * `web/src/i18n/index.ts`, Wächter-Eintrag in `tools/i18n-missing-key-lint.mjs`).
 *
 * 🚨 Wortlaut: „angenommen" heißt NUR „vom Mailserver angenommen" — nie „zugestellt" oder „gelesen". Zustellung und
 *    Lesen werden nicht erfasst (kein Tracking). Die Schlüssel `customers.mailVerlauf.status.*` entsprechen
 *    `App\Service\Mail\MailVerlaufStatus` (Server), `…art.*` den Arten in `App\Service\Mail\MailArtKatalog`.
 */
export const mailVerlaufDe = {
  'customers.detail.emailsTab': 'Tab: E-Mails',
  'customers.mailVerlauf.tab': 'E-Mails',
  'customers.mailVerlauf.titel': 'E-Mail-Verlauf',
  'customers.mailVerlauf.info':
    '„Vom Mailserver angenommen“ heißt: Der Mailserver, über den die Mail verschickt wurde (Ihr eigener oder der BISpicy-Versand), hat sie zur Weiterleitung angenommen. Ob sie beim Empfänger ankam oder gelesen wurde, wird nicht erfasst – der Eintrag ist daher kein Nachweis, dass die Mail dem Kunden zugegangen ist.',
  'customers.mailVerlauf.leer': 'Für diesen Kunden wurden noch keine E-Mails protokolliert.',
  'customers.mailVerlauf.laedt': 'Lädt …',
  'customers.mailVerlauf.ladeFehler': 'Der E-Mail-Verlauf konnte nicht geladen werden.',
  'customers.mailVerlauf.spalte.datum': 'Datum',
  'customers.mailVerlauf.spalte.art': 'Art',
  'customers.mailVerlauf.spalte.bezug': 'Bezug',
  'customers.mailVerlauf.spalte.status': 'Status',
  'customers.mailVerlauf.spalte.versandweg': 'Versandweg',
  'customers.mailVerlauf.spalte.empfaenger': 'Empfänger',
  'customers.mailVerlauf.status.angenommen': 'Vom Mailserver angenommen',
  'customers.mailVerlauf.status.umgeleitet': 'Testmodus: umgeleitet',
  'customers.mailVerlauf.status.zurueckgestellt': 'Zurückgestellt',
  'customers.mailVerlauf.status.ausstehend': 'In Arbeit',
  'customers.mailVerlauf.status.fehler': 'Fehler',
  'customers.mailVerlauf.status.nicht_versendet': 'Nicht versendet',
  'customers.mailVerlauf.status.unbekannt': 'Unbekannt',
  'customers.mailVerlauf.hinweis.umgeleitet': 'Der Testmodus hat diese Mail an die Sammeladresse umgeleitet – der Kunde hat sie nicht bekommen.',
  'customers.mailVerlauf.hinweis.nicht_versendet': 'Es wurde keine Mail versendet (Testmodus gesperrt oder kein Versandweg eingerichtet).',
  'customers.mailVerlauf.versandweg.eigener_smtp': 'Eigener Mailserver',
  'customers.mailVerlauf.versandweg.bispicy': 'BISpicy-Versand',
  'customers.mailVerlauf.fehler.verbindung': 'Verbindung zum Mailserver fehlgeschlagen',
  'customers.mailVerlauf.fehler.anmeldung': 'Anmeldung am Mailserver abgelehnt',
  'customers.mailVerlauf.fehler.empfaenger_abgelehnt': 'Empfängeradresse abgelehnt',
  'customers.mailVerlauf.fehler.sonstiges': 'Versand fehlgeschlagen',
  'customers.mailVerlauf.cc': 'Kopie: {{adressen}}',
  'customers.mailVerlauf.bcc': 'Blindkopie an {{anzahl}} Adresse(n)',
  'customers.mailVerlauf.empfaengerEntfernt': 'Adresse entfernt',
  'customers.mailVerlauf.bezug.rechnung': 'Rechnung',
  'customers.mailVerlauf.bezug.auftrag': 'Auftrag',
  'customers.mailVerlauf.bezug.lieferschein': 'Lieferschein',
  'customers.mailVerlauf.bezug.angebot': 'Angebot',
  'customers.mailVerlauf.bezug.retoure': 'Retoure',
  'customers.mailVerlauf.bezug.reparatur': 'Reparatur',
  'customers.mailVerlauf.bezug.sendung': 'Sendung',
  'customers.mailVerlauf.art.invoice': 'Rechnung',
  'customers.mailVerlauf.art.delivery_note': 'Lieferschein',
  'customers.mailVerlauf.art.order': 'Auftrag',
  'customers.mailVerlauf.art.order_confirmation': 'Auftragsbestätigung',
  'customers.mailVerlauf.art.offer': 'Angebot',
  'customers.mailVerlauf.art.shipping_confirmation': 'Versandbestätigung',
  'customers.mailVerlauf.art.attachment_delivery': 'Dokumente zum Auftrag',
  'customers.mailVerlauf.art.return_label': 'Retourenlabel',
  'customers.mailVerlauf.art.repair_status': 'Reparaturstatus',
  'customers.mailVerlauf.art.voucher_sale': 'Gutschein',
  'customers.mailVerlauf.art.portal_verification': 'Kundenportal: Bestätigung',
  'customers.mailVerlauf.art.portal_password_reset': 'Kundenportal: Passwort zurücksetzen',
  'customers.mailVerlauf.art.proof_of_arrival_request': 'Gelangensbestätigung (Anfrage)',
  'customers.mailVerlauf.art.proof_of_arrival_reminder': 'Gelangensbestätigung (Erinnerung)',
  'customers.mailVerlauf.art.proof_of_arrival_confirmation': 'Gelangensbestätigung (Bestätigung)',
  'customers.mailVerlauf.art.system_campaign': 'Systemmail',
  'customers.mailVerlauf.seite': 'Seite {{seite}} von {{seiten}}',
  'customers.mailVerlauf.zurueck': 'Zurück',
  'customers.mailVerlauf.weiter': 'Weiter',
};

export const mailVerlaufEn = {
  'customers.detail.emailsTab': 'Tab: Emails',
  'customers.mailVerlauf.tab': 'Emails',
  'customers.mailVerlauf.titel': 'Email history',
  'customers.mailVerlauf.info':
    '“Accepted by the mail server” means: the mail server used for sending (your own or BISpicy sending) accepted the email for delivery. Whether it reached the recipient or was read is not recorded – so this entry is not proof that the customer received the email.',
  'customers.mailVerlauf.leer': 'No emails have been logged for this customer yet.',
  'customers.mailVerlauf.laedt': 'Loading …',
  'customers.mailVerlauf.ladeFehler': 'The email history could not be loaded.',
  'customers.mailVerlauf.spalte.datum': 'Date',
  'customers.mailVerlauf.spalte.art': 'Type',
  'customers.mailVerlauf.spalte.bezug': 'Reference',
  'customers.mailVerlauf.spalte.status': 'Status',
  'customers.mailVerlauf.spalte.versandweg': 'Sent via',
  'customers.mailVerlauf.spalte.empfaenger': 'Recipient',
  'customers.mailVerlauf.status.angenommen': 'Accepted by the mail server',
  'customers.mailVerlauf.status.umgeleitet': 'Test mode: redirected',
  'customers.mailVerlauf.status.zurueckgestellt': 'Postponed',
  'customers.mailVerlauf.status.ausstehend': 'In progress',
  'customers.mailVerlauf.status.fehler': 'Error',
  'customers.mailVerlauf.status.nicht_versendet': 'Not sent',
  'customers.mailVerlauf.status.unbekannt': 'Unknown',
  'customers.mailVerlauf.hinweis.umgeleitet': 'Test mode redirected this email to the collection address – the customer did not receive it.',
  'customers.mailVerlauf.hinweis.nicht_versendet': 'No email was sent (test mode blocked it or no sending method is set up).',
  'customers.mailVerlauf.versandweg.eigener_smtp': 'Own mail server',
  'customers.mailVerlauf.versandweg.bispicy': 'BISpicy sending',
  'customers.mailVerlauf.fehler.verbindung': 'Connection to the mail server failed',
  'customers.mailVerlauf.fehler.anmeldung': 'Login at the mail server was rejected',
  'customers.mailVerlauf.fehler.empfaenger_abgelehnt': 'Recipient address rejected',
  'customers.mailVerlauf.fehler.sonstiges': 'Sending failed',
  'customers.mailVerlauf.cc': 'Cc: {{adressen}}',
  'customers.mailVerlauf.bcc': 'Blind copy to {{anzahl}} address(es)',
  'customers.mailVerlauf.empfaengerEntfernt': 'Address removed',
  'customers.mailVerlauf.bezug.rechnung': 'Invoice',
  'customers.mailVerlauf.bezug.auftrag': 'Order',
  'customers.mailVerlauf.bezug.lieferschein': 'Delivery note',
  'customers.mailVerlauf.bezug.angebot': 'Offer',
  'customers.mailVerlauf.bezug.retoure': 'Return',
  'customers.mailVerlauf.bezug.reparatur': 'Repair',
  'customers.mailVerlauf.bezug.sendung': 'Shipment',
  'customers.mailVerlauf.art.invoice': 'Invoice',
  'customers.mailVerlauf.art.delivery_note': 'Delivery note',
  'customers.mailVerlauf.art.order': 'Order',
  'customers.mailVerlauf.art.order_confirmation': 'Order confirmation',
  'customers.mailVerlauf.art.offer': 'Offer',
  'customers.mailVerlauf.art.shipping_confirmation': 'Shipping confirmation',
  'customers.mailVerlauf.art.attachment_delivery': 'Documents for the order',
  'customers.mailVerlauf.art.return_label': 'Return label',
  'customers.mailVerlauf.art.repair_status': 'Repair status',
  'customers.mailVerlauf.art.voucher_sale': 'Voucher',
  'customers.mailVerlauf.art.portal_verification': 'Customer portal: confirmation',
  'customers.mailVerlauf.art.portal_password_reset': 'Customer portal: reset password',
  'customers.mailVerlauf.art.proof_of_arrival_request': 'Proof of arrival (request)',
  'customers.mailVerlauf.art.proof_of_arrival_reminder': 'Proof of arrival (reminder)',
  'customers.mailVerlauf.art.proof_of_arrival_confirmation': 'Proof of arrival (confirmation)',
  'customers.mailVerlauf.art.system_campaign': 'System email',
  'customers.mailVerlauf.seite': 'Page {{seite}} of {{seiten}}',
  'customers.mailVerlauf.zurueck': 'Previous',
  'customers.mailVerlauf.weiter': 'Next',
};

export const mailVerlaufTh = {
  'customers.detail.emailsTab': 'แท็บ: อีเมล',
  'customers.mailVerlauf.tab': 'อีเมล',
  'customers.mailVerlauf.titel': 'ประวัติอีเมล',
  'customers.mailVerlauf.info':
    '“เซิร์ฟเวอร์อีเมลรับแล้ว” หมายถึง เซิร์ฟเวอร์อีเมลที่ใช้ส่ง (ของคุณเองหรือระบบส่งของ BISpicy) ได้รับอีเมลไว้เพื่อส่งต่อแล้ว ส่วนอีเมลถึงผู้รับหรือถูกอ่านหรือไม่นั้นไม่มีการบันทึก รายการนี้จึงไม่ใช่หลักฐานว่าลูกค้าได้รับอีเมลแล้ว',
  'customers.mailVerlauf.leer': 'ยังไม่มีการบันทึกอีเมลสำหรับลูกค้ารายนี้',
  'customers.mailVerlauf.laedt': 'กำลังโหลด …',
  'customers.mailVerlauf.ladeFehler': 'โหลดประวัติอีเมลไม่สำเร็จ',
  'customers.mailVerlauf.spalte.datum': 'วันที่',
  'customers.mailVerlauf.spalte.art': 'ประเภท',
  'customers.mailVerlauf.spalte.bezug': 'เอกสารอ้างอิง',
  'customers.mailVerlauf.spalte.status': 'สถานะ',
  'customers.mailVerlauf.spalte.versandweg': 'ช่องทางส่ง',
  'customers.mailVerlauf.spalte.empfaenger': 'ผู้รับ',
  'customers.mailVerlauf.status.angenommen': 'เซิร์ฟเวอร์อีเมลรับแล้ว',
  'customers.mailVerlauf.status.umgeleitet': 'โหมดทดสอบ: เปลี่ยนเส้นทางแล้ว',
  'customers.mailVerlauf.status.zurueckgestellt': 'พักไว้ก่อน',
  'customers.mailVerlauf.status.ausstehend': 'กำลังดำเนินการ',
  'customers.mailVerlauf.status.fehler': 'ผิดพลาด',
  'customers.mailVerlauf.status.nicht_versendet': 'ไม่ได้ส่ง',
  'customers.mailVerlauf.status.unbekannt': 'ไม่ทราบ',
  'customers.mailVerlauf.hinweis.umgeleitet': 'โหมดทดสอบเปลี่ยนเส้นทางอีเมลนี้ไปยังที่อยู่รวม ลูกค้าไม่ได้รับอีเมลนี้',
  'customers.mailVerlauf.hinweis.nicht_versendet': 'ไม่มีการส่งอีเมล (โหมดทดสอบบล็อกอยู่ หรือยังไม่ได้ตั้งค่าช่องทางส่ง)',
  'customers.mailVerlauf.versandweg.eigener_smtp': 'เซิร์ฟเวอร์อีเมลของคุณเอง',
  'customers.mailVerlauf.versandweg.bispicy': 'ระบบส่งของ BISpicy',
  'customers.mailVerlauf.fehler.verbindung': 'เชื่อมต่อเซิร์ฟเวอร์อีเมลไม่สำเร็จ',
  'customers.mailVerlauf.fehler.anmeldung': 'เซิร์ฟเวอร์อีเมลปฏิเสธการเข้าสู่ระบบ',
  'customers.mailVerlauf.fehler.empfaenger_abgelehnt': 'ที่อยู่ผู้รับถูกปฏิเสธ',
  'customers.mailVerlauf.fehler.sonstiges': 'การส่งไม่สำเร็จ',
  'customers.mailVerlauf.cc': 'สำเนา: {{adressen}}',
  'customers.mailVerlauf.bcc': 'สำเนาลับถึง {{anzahl}} ที่อยู่',
  'customers.mailVerlauf.empfaengerEntfernt': 'ลบที่อยู่แล้ว',
  'customers.mailVerlauf.bezug.rechnung': 'ใบแจ้งหนี้',
  'customers.mailVerlauf.bezug.auftrag': 'คำสั่งซื้อ',
  'customers.mailVerlauf.bezug.lieferschein': 'ใบส่งของ',
  'customers.mailVerlauf.bezug.angebot': 'ใบเสนอราคา',
  'customers.mailVerlauf.bezug.retoure': 'การคืนสินค้า',
  'customers.mailVerlauf.bezug.reparatur': 'งานซ่อม',
  'customers.mailVerlauf.bezug.sendung': 'พัสดุ',
  'customers.mailVerlauf.art.invoice': 'ใบแจ้งหนี้',
  'customers.mailVerlauf.art.delivery_note': 'ใบส่งของ',
  'customers.mailVerlauf.art.order': 'คำสั่งซื้อ',
  'customers.mailVerlauf.art.order_confirmation': 'ยืนยันคำสั่งซื้อ',
  'customers.mailVerlauf.art.offer': 'ใบเสนอราคา',
  'customers.mailVerlauf.art.shipping_confirmation': 'ยืนยันการจัดส่ง',
  'customers.mailVerlauf.art.attachment_delivery': 'เอกสารแนบของคำสั่งซื้อ',
  'customers.mailVerlauf.art.return_label': 'ป้ายส่งคืนสินค้า',
  'customers.mailVerlauf.art.repair_status': 'สถานะงานซ่อม',
  'customers.mailVerlauf.art.voucher_sale': 'บัตรของขวัญ',
  'customers.mailVerlauf.art.portal_verification': 'พอร์ทัลลูกค้า: ยืนยันอีเมล',
  'customers.mailVerlauf.art.portal_password_reset': 'พอร์ทัลลูกค้า: รีเซ็ตรหัสผ่าน',
  'customers.mailVerlauf.art.proof_of_arrival_request': 'หนังสือยืนยันการรับสินค้า (คำขอ)',
  'customers.mailVerlauf.art.proof_of_arrival_reminder': 'หนังสือยืนยันการรับสินค้า (เตือน)',
  'customers.mailVerlauf.art.proof_of_arrival_confirmation': 'หนังสือยืนยันการรับสินค้า (ยืนยัน)',
  'customers.mailVerlauf.art.system_campaign': 'อีเมลระบบ',
  'customers.mailVerlauf.seite': 'หน้า {{seite}} จาก {{seiten}}',
  'customers.mailVerlauf.zurueck': 'ก่อนหน้า',
  'customers.mailVerlauf.weiter': 'ถัดไป',
};

export const mailVerlaufTranslations = {
  de: mailVerlaufDe,
  en: mailVerlaufEn,
  th: mailVerlaufTh,
};
